import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AppStorageService {
    private readonly keys = {
        hasViewedGoOverview: 'hasViewedGoOverview',
        sideBarIsCollapsed: 'sideBarIsCollapsed',
        contactCiviId: 'contactCiviId',
    } as const;

    getHasViewedGoOverview(): boolean {
        return localStorage.getItem(this.keys.hasViewedGoOverview) === 'true';
    }

    setHasViewedGoOverview(value: boolean) {
        localStorage.setItem(this.keys.hasViewedGoOverview, value.toString());
    }

    getSideNavCollapsed(): boolean {
        return localStorage.getItem(this.keys.sideBarIsCollapsed) === 'true';
    }

    setSidenavCollapsed(isCollapsed: boolean): void {
        localStorage.setItem(
            this.keys.sideBarIsCollapsed,
            isCollapsed.toString(),
        );
    }

    getContactCiviId(): number | null {
        const civiId = localStorage.getItem(this.keys.contactCiviId);
        return civiId ? Number(civiId) : null;
    }

    setContactCiviId(civiId: number): void {
        localStorage.setItem(this.keys.contactCiviId, civiId.toString());
    }

    clearContactCiviId(): void {
        localStorage.removeItem(this.keys.contactCiviId);
    }
}
